import type { SxProps, Theme } from '@mui/material'

export const styles = {
  root: {
    typography: 'caption',
    color: (theme: Theme) => theme.palette.text.secondary,
    marginBlockStart: ({ spacing }) => spacing(1),
  },
  clamped: {
    display: '-webkit-box',
    WebkitLineClamp: 3,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
  },
  expanded: {
    display: 'block',
  },
  linkButton: {
    padding: 0,
    minWidth: 'auto',
    textTransform: 'none',
    typography: 'caption',
    fontWeight: 500,
    textDecoration: 'none',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
} satisfies Record<string, SxProps<Theme>>
